import { ParsedUrlQueryInput } from 'node:querystring';

import { useUrlGenerator } from '../../../../shared/hooks/useUrlGenerator';

export function useGenerateItineraryListUrl() {
    const { generatePath, generateUrl } = useUrlGenerator();

    return ({
        destinationSlug,
        page,
        filters,
        absolute,
    }: {
        destinationSlug: string;
        page: number;
        filters: ParsedUrlQueryInput;
        absolute: boolean;
    }) => {
        const generate = absolute ? generateUrl : generatePath;

        return generate('itinerary_list', {
            destinationSlug,
            ...filters,
            p: page > 1 ? page : undefined,
        });
    };
}
